type File = {
  uri: string;
  type: string;
  size: number;
  name: string;
};

const file: File = {
  uri: "",
  type: "",
  size: 0,
  name: "",
};

export type { File };

export { file };
